$('.home-testimonials-slider').slick({
  dots: true,
  infinite: true,
  speed: 300,
  slidesToShow: 1,
  autoplay: true,
  autoplaySpeed: 3000,
  adaptiveHeight: true,
  draggable: false,
  pauseOnFocus: false,
  pauseOnHover: false,
});

$('.homeCollectionsSlider').slick({
  dots: true,
  infinite: false,
  speed: 300,
  slidesToShow: 4,
  slidesToScroll: 1,
  draggable: false,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1,
        infinite: true,
        dots: true
      }
    },
    {
      breakpoint: 690,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
        draggable: true,
      }
    }
  ]
});

$('.heroCat').slick({
  dots: true,
  infinite: false,
  speed: 300,
  slidesToShow: 3,
  slidesToScroll: 3,
  responsive: [
    {
      breakpoint: 991,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2,
        infinite: true,
        dots: true
      }
    },
    {
      breakpoint: 690,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        draggable: true,
      }
    }
  ]
});

$('.home-best-collections .grid').slick({
  dots: true,
  infinite: false,
  speed: 300,
  slidesToShow: 2,
  slidesToScroll: 1,
  draggable: false,
  responsive: [
    {
      breakpoint: 690,
      settings: {
        draggable: true,
      }
    }
  ]
});

// productMainSlider 

// if (window.matchMedia('(max-width: 991px)').matches)
// {
//     $('.productMainSlider').slick({
//       dots: false,
//       arrows: true,
//       infinite: true,
//       speed: 300,
//       slidesToShow: 1,
//       slidesToScroll: 1,
//       centerMode: true,
//       centerPadding: '150px',
//       responsive: [
//         {
//           breakpoint: 690,
//           settings: {
//             centerPadding: '70px',
//           }
//         }
//       ]
//   });
// }

// Show the first tab and hide the rest
// $('#tabs-nav li:first-child').addClass('active');
// $('.tab-content').hide();
// $('.tab-content:first').show();

// Click function



$('#tabs-nav li').on('click', function() {
    
    if($(this).hasClass('active')) {
        $(this).removeClass('active');
        $('.tab-content').hide();
        return false;
    }
    else {
        $('#tabs-nav li').removeClass('active');
        $(this).toggleClass('active');
        $('.tab-content').hide();
        var activeTab = $(this).find('a').attr('href');
        $(activeTab).slideToggle();
        return false;
    }
});


/*$('.img-slider').slick({
  infinite: true,
  slidesToShow: 1,
  slidesToScroll: 1,
  dots: true,
  arrows: false
});*/

$('a[href^="#"]').on('click', function (event) {
  const disabled = this.hasAttribute('data-disabled-scroll');
  const target = this.getAttribute('href') && this.getAttribute('href') != '#' ? $(this.getAttribute('href')) : null;
  console.log('target=', target);
  console.log('disabled=', disabled);
  if (target && target.length && !disabled) {
    event.preventDefault();
    $('html, body').stop().animate({
      scrollTop: target.offset().top,
    }, 1000);
  }
});


$('.grid__item.right_grid__item .tabs li:first-child').click();
$('.productsTabContent #tabs-nav li:first-child').addClass('active');
$('.productsTabContent #tabs-content #tab1').show();

var homePageSafe = $('.template-product #shopify-section-text-columns').html();
$('.homePageSafe').html(homePageSafe);


